import { render, staticRenderFns } from "./SelectPoint.vue?vue&type=template&id=d6f4f4d4&"
import script from "./SelectPoint.vue?vue&type=script&lang=js&"
export * from "./SelectPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports